import { Env, readFromEnv } from "@cinch-nx/environments";
import { getStoryBySlug } from "@cinch-nx/data-storyblok";
import { setTag, tagError, traceFunction } from "@core/datadog-server";
export const VEHICLE_SEARCH_URL = `${readFromEnv(Env.SearchServiceUrl)}/vehicles`;
export async function getStaticPropsfn({ preview =false  }) {
    var ref, ref1;
    const story = await getStoryBySlug("about-us", {
        version: preview ? "draft" : "published"
    });
    if (!story) {
        setTag("page.response-code", "500");
        throw new Error("Unable to fetch `about-us` story from storyblok");
    }
    const HeroProps = (ref = story.content) === null || ref === void 0 ? void 0 : (ref1 = ref.Hero) === null || ref1 === void 0 ? void 0 : ref1[0];
    const carTotal = await fetch(VEHICLE_SEARCH_URL).then((response)=>response.json()).then((data)=>data.searchResultsCount).catch((error)=>{
        if (error instanceof Error || typeof error === "string") {
            tagError(error);
        }
        return 0;
    });
    setTag("response.code", 200);
    setTag("page.rendered", "ISR");
    setTag("page.revalidate-in", "300s");
    setTag("page.name", "about-us");
    setTag("page.params", JSON.stringify({
        preview,
        carTotal
    }, null, 2));
    setTag("page.response-code", "200");
    return {
        props: {
            story,
            preview,
            generatedAt: Date.now(),
            layoutProps: {
                heroProps: HeroProps,
                showBorderRadius: true
            },
            carTotal
        },
        revalidate: 300
    };
}
export const getStaticProps = traceFunction("about-us.getStaticProps", getStaticPropsfn);
